import styled from '@emotion/styled';

import { darkGrey } from '~/styles';

export const HeroImage = styled.img`
  height: auto;
  max-width: 100%;
  object-fit: contain;
  max-height: 400px;
`;

export const Container = styled.div`
  width: 100%;
  background-color: ${darkGrey};
  display: flex;
  justify-content: center;
`;
